import { ElementRef } from '@angular/core';

export interface NGXCMModuleConfig {
    preloader: ElementRef<any>
}